import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';
import { cn } from '@/utils/cn';
import { TYPE } from '@/lib/typography';

interface RadioProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: ReactNode;
  hint?: ReactNode;
}

export const Radio = forwardRef<HTMLInputElement, RadioProps>(function Radio(
  { className, label, hint, id, disabled, ...props },
  ref,
) {
  const inputId = id ?? props.name;
  return (
    <label
      className={cn(
        'group/rd flex min-h-10 cursor-pointer items-start gap-s3',
        disabled && 'cursor-not-allowed text-ds-muted',
        className,
      )}
    >
      <span className="relative mt-s1 inline-flex h-5 w-5 shrink-0">
        <input ref={ref} id={inputId} type="radio" disabled={disabled} className="peer sr-only" {...props} />
        <span
          className={cn(
            'flex h-5 w-5 items-center justify-center rounded-full border-[1.5px] border-ds-field bg-ds-card',
            'peer-focus-visible:shadow-ring peer-disabled:border-ds-disabled-border peer-disabled:bg-ds-disabled',
            'group-has-[:checked]/rd:border-ds-teal',
          )}
        >
          <span className="hidden h-2.5 w-2.5 rounded-full bg-ds-teal group-has-[:checked]/rd:block" />
        </span>
      </span>
      {(label || hint) && (
        <span className="min-w-0">
          {label ? <span className={cn(TYPE.body, 'block')}>{label}</span> : null}
          {hint ? <span className={cn(TYPE.small, 'block text-ds-muted')}>{hint}</span> : null}
        </span>
      )}
    </label>
  );
});
